import React, { useState } from "react";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import { ProjectPermissionsEnum } from "src/utils/PermissionsEnums";
import {
  changeSettingsObjectUuid,
  ChangeSettingsSectionParam,
  removeViewSettingsParam,
} from "src/app/SettingsModal/methods";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";
import ExtensionsListItemContent from "./ExtensionsListItemContent";
import { ExtensionsSection } from "../../Extensions";
import ExtensionListItemEditButton from "./ExtensionListItemEditButton";

interface Props {
  permissions: { project: string[]; workspace: string[] };
  setExtensionsSection: (section: ChangeSettingsSectionParam) => void;
}

const ExtensionListCreatorContentMonitoring = ({
  permissions,
  setExtensionsSection,
}: Props) => {
  const [toggled, setToggled] = useState(false);

  const { creatorContentMonitors } = useSelector(
    (state: RootState) => state.extensionReducer,
  );

  const history = useHistory();

  return (
    <ExtensionsListItemContent
      dataQa="ws_creator_content_monitoring"
      name={
        <IDHFormattedMessage
          id="ws_creator_content_monitoring"
          defaultMessage="Creator content monitoring "
        />
      }
      description={
        <IDHFormattedMessage
          id="ws_automatically_scan_selected_creators_publications"
          defaultMessage="Automatically scan selected creators’ publications for specific keywords, tags, or hashtags."
        />
      }
      controls={
        creatorContentMonitors.length > 0 ? (
          <ExtensionListItemEditButton
            onClick={() => {
              setExtensionsSection(ExtensionsSection.CreatorContentMonitoring);
              removeViewSettingsParam(history, "objectUuid");
            }}
            extensionType="creator-content-monitoring"
          />
        ) : (
          <CustomSwitch
            checked={toggled}
            onChange={async (e) => {
              setToggled(e.target.checked);
              setTimeout(() => {
                setExtensionsSection(
                  ExtensionsSection.CreatorContentMonitoring,
                );
                changeSettingsObjectUuid(history, "create-new");
              }, 200);
            }}
            disabled={
              !permissions?.project?.includes(
                ProjectPermissionsEnum.MANAGE_PROJECT_CONFIGURATION,
              )
            }
          />
        )
      }
    />
  );
};

export default ExtensionListCreatorContentMonitoring;
